<template>
    <div class="reservations-tabs__container">
        <ul class="micro-tabs">
            <li
                v-for="tab in tabs"
                :key="tab.id"
                :class="{ active: tab.id === selected }"
                @click.prevent="onSelect(tab.id)"
            >
                {{ tab.label }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'ReservationsTabs',
    props: {
        tabs: {
            type: Array,
            default: () => ([
                { id: 'reservations', label: 'Reservations' },
                { id: 'payment-links', label: 'Payment Links' }
            ])
        },
        selected: {
            type: String,
            default: 'reservations'
        }
    },
    emits: ['select', 'update:selected'],
    methods: {
        onSelect(id) {
            this.$emit('select', id);
            this.$emit('update:selected', id);
        }
    }
}
</script>

<style lang="scss" scoped>
.reservations-tabs__container {
    margin-top: 1.5rem;
}

.micro-tabs {
    margin: 0;
    padding: 0;

    > li {
        display: inline-block;
        list-style: none;
        margin-right: 0.5rem;
        padding: 0.4rem 1rem;
        color: #35495e;
        background: #f7f8fa;
        border: 1px solid rgba(0, 0, 0, 0.12);
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        cursor: pointer;
    }

    > li.active {
        font-weight: 600;
        background: #ffffff;
        border-color: rgba(0, 0, 0, 0.16);
        border-bottom-color: transparent;
        margin-bottom: -1px;
    }
}
</style>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';

    .reservations-panel {
        border: 1px solid $light;
        border-radius: 4px;
    }

    .reservations-tabs__container + .reservations-panel,
    .reservations-tabs__container + div .reservations-panel {
        border-top-left-radius: 0;
        border-top: 0;
    }
</style>



// WEBPACK FOOTER //
// ReservationsTabs.vue?4053498a